export default "__VITE_ASSET__DViF733N__"